import { useCallback, useEffect } from "react";
import { useAppDispatch, useAppSelector } from "@/lib/store";
import {
  fetchHomeData,
  fetchStats,
  fetchChartData,
  fetchUpcomingAppointments,
  setChartTimeRange,
  clearError,
  clearData,
} from "./home.slice";
import { ChartTimeRange } from "./home.entity";

export const useHome = () => {
  const dispatch = useAppDispatch();
  const homeState = useAppSelector((state) => state.home);
  const { stats, chartData, chartTimeRange, upcomingAppointments, loading, error, lastUpdated } = homeState;

  // Load home data on mount
  useEffect(() => {
    dispatch(fetchHomeData(undefined));
  }, [dispatch]);

  // Auto-refresh every 5 minutes
  useEffect(() => {
    const interval = setInterval(() => {
      dispatch(fetchStats(undefined));
      dispatch(fetchChartData(chartTimeRange));
      dispatch(fetchUpcomingAppointments());
    }, 5 * 60 * 1000); // 5 minutes

    return () => clearInterval(interval);
  }, [dispatch, chartTimeRange]);

  const refreshData = useCallback(() => {
    dispatch(fetchHomeData(undefined));
  }, [dispatch]);

  const refreshStats = useCallback(() => {
    dispatch(fetchStats(undefined));
  }, [dispatch]);

  const updateChartTimeRange = useCallback(
    (range: ChartTimeRange) => {
      dispatch(setChartTimeRange(range));
      dispatch(fetchHomeData(range));
    },
    [dispatch]
  );

  const handleClearError = useCallback(() => {
    dispatch(clearError());
  }, [dispatch]);

  const handleClearData = useCallback(() => {
    dispatch(clearData());
  }, [dispatch]);

  return {
    stats,
    chartData,
    chartTimeRange,
    setChartTimeRange: updateChartTimeRange,
    upcomingAppointments,
    loading,
    error,
    lastUpdated,
    refreshData,
    refreshStats,
    clearError: handleClearError,
    clearData: handleClearData,
  };
};

